import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { DataTable } from 'CommonComponent';

const CategorySummaryList = ({ extraFiltersState, setExtraFiltersState, taskFilterValue = "" }) => {
    const [columns, setColumns] = useState([]);
    const { data, headers, loading } = useSelector(state => state.timesheetReportsState.categorySummary);

    useEffect(() => {
        if (headers) {
            const generatedColumns = generateColumns(headers);
            setColumns(generatedColumns);
        }
    }, [headers]);

    const formatValue = (value) => {
        if (typeof value === 'number') {
            return (
                <span>
                    {value.toFixed(2)}
                </span>
            )
        }
        return value;
    };

    const generateColumns = (headers) => {
        return Object.entries(headers).map(([key, header]) => {
            return {
                id: key,
                header: header,
                accessor: (row) => row[key],
                cell: (value) => formatValue(value),
                sortable: true,
                searchable: true,
            }
        });
    };

    const filteredData = (Array.isArray(data) ? data : []).filter((row) => {
        if (!taskFilterValue) return true;
        const taskValue = String(row?.category_task || row?.task || "");
        return taskValue === taskFilterValue;
    });

    return (
        <div className="monthlybilling-table-container">
            <DataTable
                columns={columns}
                data={filteredData}
                serverSide={false}
                showSearch={false}
                loading={loading}
            />
        </div>
    );
};

export default CategorySummaryList;
